import { withTranslation } from '@application/i18n/with_translation';
import { TextLink } from '@cellula/react';
import { useVonageEncryptionWarning } from './use_vonage_excryption_warning.hook';

interface Props {
	type: 'dialog' | 'notificationAlert';
}

export function VonageEncryptionWarningText({ type }: Props) {
	const { platform, appConfig } = useVonageEncryptionWarning();

	if (type === 'dialog') {
		if (platform.android) {
			return withTranslation(`VonageEncryptionWarning.Dialog.${appConfig != null ? 'HasApp' : 'NoApp'}.Android`);
		}
		if (platform.ios) {
			return withTranslation(`VonageEncryptionWarning.Dialog.${appConfig != null ? 'HasApp' : 'NoApp'}.iOS`);
		}

		return withTranslation(`VonageEncryptionWarning.Dialog.Desktop`);
	}

	if (type === 'notificationAlert') {
		if (platform.android || platform.ios) {
			if (appConfig == null) {
				return withTranslation(`VonageEncryptionWarning.NotificationAlert.NoApp.${platform.ios ? 'iOS' : 'Android'}`);
			}
			if (appConfig != null && appConfig.appDownloadUrl) {
				return (
					<>
						{withTranslation(`VonageEncryptionWarning.NotificationAlert.HasApp.${platform.ios ? 'iOS' : 'Android'}.Part1`)}
						<TextLink href={appConfig.appDownloadUrl} target='_blank'>
							{withTranslation(`VonageEncryptionWarning.NotificationAlert.HasApp.${platform.ios ? 'iOS' : 'Android'}.Link`)}
						</TextLink>
						{withTranslation(`VonageEncryptionWarning.NotificationAlert.HasApp.${platform.ios ? 'iOS' : 'Android'}.Part2`)}
					</>
				);
			}
		}

		return withTranslation(`VonageEncryptionWarning.NotificationAlert.Desktop`);
	}

	return null;
}
